<button (click)="socialSignIn()"
  class="w-100 border mb-3 btn btn-outline fs-16 fw-500 text-secondary d-flex align-items-center justify-content-center google-signin-btn">
  <img src="assets/images/icons/google.svg" alt="" class="mx-2"> {{ googleButtonText }}
</button>